import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-900">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-2">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-background-300/80 mb-2">{appData.subtitle}</p>
            <p className="text-xs md:text-sm text-background-400/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              {appData.description}
            </p>

            <ul className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
              {appData.features.map((feat) => (
                <li
                  key={feat}
                  className="flex items-center gap-1.5 text-xs text-background-300/80 whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                  </span>
                  {feat}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              {appData.badges.map((badge) => (
                <a
                  key={badge.label}
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 hover:bg-background-100 text-foreground-900 font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className={`${badge.icon} text-lg`}></i>
                  {badge.label}
                </a>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0 flex items-center gap-6">
            <div className="hidden md:block">
              <img
                src={appData.qrImage}
                alt="草民影院APP下载二维码"
                className="w-32 h-32 rounded-lg object-cover bg-background-50 p-2"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
              <p className="text-center text-xs text-background-400/60 mt-2 whitespace-nowrap">扫码下载</p>
            </div>
            <div className="w-48 md:w-56">
              <img
                src={appData.appImage}
                alt="草民影院APP界面截图"
                className="w-full h-auto rounded-xl object-cover"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}